var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-permission"},[_c('img',{staticClass:"icon",attrs:{"src":require('@/assets/images/warning-icon.svg')}}),_c('span',[_vm._v(_vm._s(_vm.message || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }